// Mapper for employee contract delete operations
import type {
  LC_DeleteEmployeeContractIn,
  LC_DeleteEmployeeContractOut,
  DeleteEmployeeContractRequest,
  DeleteEmployeeContractResponse,
} from '../types/employeeContractDelete.types';


/**
 * Maps internal delete request to API transport DTO
 * @param request Internal delete request model
 * @returns LC_DeleteEmployeeContractIn for API
 */
export function mapDeleteRequestToTransport(
  request: DeleteEmployeeContractRequest,
): LC_DeleteEmployeeContractIn {
  return {
    employeeId: request.employeeId,
    contractNumberREX: request.contractNumberREX,
  };
}

/**
 * Maps API transport DTO to internal delete response model
 * @param transportDto LC_DeleteEmployeeContractOut from API
 * @returns DeleteEmployeeContractResponse internal model
 */
export function mapDeleteTransportToResponse(
  transportDto: LC_DeleteEmployeeContractOut,
): DeleteEmployeeContractResponse {
  return {
    contractId: transportDto.employeeContractID,
    contractNumber: transportDto.contractNumberREX,
    message: transportDto.message || '',
  };
}
